import { Decorators } from "../decorators";

@Decorators.registerInterface('Serenity.IAsyncInit')
export class IAsyncInit {
}